<template>
  <div id="app">
    <head>
    <meta charset="utf-8">
    <link rel="shortcut icon" type="image/png" href="/assets/favicon/img/favicon.png"/>
    <title>METALIX.UZ</title>
    ...
</head>
      <header-nav/>
      <router-view></router-view>
      <footer-sec/>
  </div>
</template>

<script>
import HeaderNav from './components/Header.vue'
import FooterSec from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    HeaderNav,
    FooterSec
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
